
import GDPRPanel from './GDPRPanel.vue'
export default {
  props: {
    labels: {
      type: Object,
      required: true,
      default: () => {}
    },
    check: {
      type: Object,
      required: true,
      default: () => {}
    },
    isLogged: {
      type: Boolean,
      required: false,
      default: false
    },
    noCheckbox: {
      type: Boolean,
      required: false,
      default: false
    },
    mandatory: {
      type: Boolean,
      required: true,
      default: false
    },
    insideModal: {
      type: Boolean,
      required: false,
      default: false
    },
    fieldError: {
      type: String,
      default: ''
    },
    font: {
      type: String,
      default: ''
    },
    openLinksInNewTab: {
      type: Boolean,
      default: false
    }
  },
  components: {
    GDPRPanel
  },
  computed: {
    displayCheck() {
      let display = true
      if (this.check.content.logged) {
        if (this.isLogged) {
          display = this.check.content.logged.key === 'yes'
        } else {
          display = this.check.content.logged.key === 'no'
        }
      }
      return display
    },
    classTxt() {
      return {
        'font-gotham': this.font === 'Gotham'
      }
    }
  },
  data() {
    return {
      selected: null,
      panelOpened: false
    }
  },
  methods: {
    replaceLinksText() {
      const checkContent = this.check.content
      let checkText = checkContent.text.title
      let anchor1 = checkContent.anchor1 ? '#' + checkContent.anchor1 : ''
      let anchor2 = checkContent.anchor2 ? '#' + checkContent.anchor2 : ''
      if (checkContent.link) {
        let a
        let targetAttribute = this.openLinksInNewTab ? 'target="_blank"' : ''
        if (checkContent.link.modalPageId) {
          a = `<a data-pageId="${checkContent.link.modalPageId}" data-anchorId="${anchor1}" class="gdpr-modal-link ${
            this.classTxt['font-gotham'] ? 'font-gotham' : ''
          }">${checkContent.link.text}</a>`
        } else if (checkContent.link.urlExterna) {
          a = `<a href="${checkContent.link.urlExterna}" class="gdpr-modal-link ${
            this.classTxt['font-gotham'] ? 'font-gotham' : ''
          }" ${targetAttribute}>${checkContent.link.text}</a>`
        } else if (checkContent.link.linkUrl) {
          a = `<a href="${checkContent.link.linkUrl}" class="gdpr-modal-link ${
            this.classTxt['font-gotham'] ? 'font-gotham' : ''
          }" ${targetAttribute}>${checkContent.link.text}</a>`
        }
        checkText = checkText.replace('#link1', a)
      }
      if (checkContent.link1) {
        let b
        let targetAttribute = this.openLinksInNewTab ? 'target="_blank"' : ''
        if (checkContent.link1.modalPageId) {
          b = `<a data-pageId="${checkContent.link1.modalPageId}" data-anchorId="${anchor2}" class="gdpr-modal-link ${
            this.classTxt['font-gotham'] ? 'font-gotham' : ''
          }">${checkContent.link1.text}</a>`
        } else if (checkContent.link1.urlExterna) {
          b = `<a href="${checkContent.link1.urlExterna}" class="gdpr-modal-link ${
            this.classTxt['font-gotham'] ? 'font-gotham' : ''
          }" ${targetAttribute}>${checkContent.link1.text}</a>`
        } else if (checkContent.link1.linkUrl) {
          b = `<a href="${checkContent.link1.linkUrl}" class="gdpr-modal-link ${
            this.classTxt['font-gotham'] ? 'font-gotham' : ''
          }" ${targetAttribute}>${checkContent.link1.text}</a>`
        }
        checkText = checkText.replace('#link2', b)
      }
      if (checkText.includes('#modalCancelConditions')) {
        const c = `<a id="#modalCancelConditions">${app.i18n.t('lblEServicingCancelConditionsLink')}</a>`
        checkText = checkText.replace('#modalCancelConditions', c)
      }
      if (checkText.includes('#modalReservationConditions')) {
        const c = `<a id="#modalReservationConditions" class="link">${app.i18n.t('lblCOReservationConditions')}</a>`
        checkText = checkText.replace('#modalReservationConditions', c)
      }
      return checkText
    },
    selectGDPR(id, selected) {
      this.$emit('selectGDPR', {type: id, value: selected})
    },
    openPanel() {
      this.panelOpened = !this.panelOpened
    }
  },
  mounted() {
    if (document.querySelector('.gdpr-modal-link')) {
      document.querySelectorAll('.gdpr-modal-link').forEach(element => {
        if (!element.hasAttribute('href')) {
          element.addEventListener('click', event => {
            const modalPageId = event.target.dataset.pageid
            const anchor = event.target.dataset.anchorid
            this.$emit('openGDPRModal', {modalPageId, anchor})
          })
        }
      })
    }
  }
}
